module.exports = __webpack_public_path__ + "img/grey-upload.933277e7.svg";